import { unstable_ClassNameGenerator as ClassNameGenerator } from "@mui/material/className";

const APP_SHORT = process.env.NEXT_PUBLIC_APP_SHORT;

ClassNameGenerator.configure((componentName) =>
    process.env.NODE_ENV === "development"
        ? componentName
        : `_${componentName.toUpperCase().replace("MUI", `${APP_SHORT}-`)}`
);
